import React from "react";

import SvgXCircle from "@uui/XCircle";

import { Stack, Typography } from "@mui/material";

import useBillingPlanSubscriptionContext from "@app/common/hooks/useBillingPlanSubscriptionContext";
import { parseUTCDateTimeFromString } from "@app/utils/utils";

import ConfirmationModal from "@rui/ConfirmationModal";

const LOST_FEATURES = [
  "Workspace benchmarks, branding, and permissions",
  "Advanced meeting metrics",
  "Participant-level reporting",
  "Meeting transcription",
];

const DowngradeModalItem = ({ title }: { title: string }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <SvgXCircle sx={{ color: "shades.negative.500" }} />
      <Typography variant="bodyPrimaryReg" sx={{ color: "shades.neutral.600" }}>
        {title}
      </Typography>
    </Stack>
  );
};

const DowngradeModal = (props: {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
}) => {
  const { currentPlan, subscription } = useBillingPlanSubscriptionContext();
  const expirationDate = subscription.currentPeriodEnd
    ? parseUTCDateTimeFromString(subscription.currentPeriodEnd).toFormat(
        "MMMM d, y"
      )
    : null;

  return (
    <ConfirmationModal
      {...props}
      title="Are you sure?"
      confirmProps={{ label: "Downgrade to Free" }}
      cancelProps={{ label: `Keep my ${currentPlan.label} Plan` }}
      size="md"
      actionsContainerProps={{
        sx: {
          rowGap: 1,
          flexDirection: { xxs: "column-reverse", sm: "row" },
        },
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="bodyPrimaryReg" color="shades.neutral.700">
          When you downgrade to a Free Plan, you will lose access to features
          such as:
        </Typography>
        <Stack spacing={1}>
          {LOST_FEATURES.map((feature) => (
            <DowngradeModalItem key={feature} title={feature} />
          ))}
        </Stack>
        <Typography variant="bodySecondaryReg" color="shades.neutral.600">
          {currentPlan.label} features will continue to be available through the
          end of your current billing term, {expirationDate}.
        </Typography>
      </Stack>
    </ConfirmationModal>
  );
};

export default DowngradeModal;
